import { render } from "./AccessibleSearchInput.3.vue?vue&type=template&id=33edd6a5&scoped=true&ts=true"
import script from "./AccessibleSearchInput.3.vue?vue&type=script&lang=ts"
export * from "./AccessibleSearchInput.3.vue?vue&type=script&lang=ts"

import "./AccessibleSearchInput.3.vue?vue&type=style&index=0&id=33edd6a5&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33edd6a5"]])

export default __exports__